type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const SERVICES_LETTER_PAGES: ImpactModulePages = {
  SERVICE_LETTER: {
    name: 'Cartas de serviços',
    description: 'Gestão das cartas de serviços',
  },
  SERVICE_SUBJECT: {
    name: 'Assuntos de serviços',
    description: 'Gestão dos assuntos de serviços',
  },
  SERVICE: {
    name: 'Serviços',
    description: 'Gestão dos serviços',
  },
  SERVICE_TARGET_AUDIENCE: {
    name: 'Públicos-alvo',
    description: 'Gestão dos públicos-alvo',
  },
  PLACE: {
    name: 'Locais',
    description: 'Gestão dos locais',
  },
  ACTIVITY_TYPE: {
    name: 'Tipos de atividades',
    description: 'Gestão dos tipos de atividades',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
}
